var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcAlertBlue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.89614 1.24806C8.1933 0.516133 8.91138 0 9.75 0C10.5886 0 11.3067 0.516133 11.6039 1.24806C14.5702 2.06062 16.75 4.77556 16.75 7.99961V12.6966L18.5821 15.4445C18.7866 15.7514 18.8057 16.1459 18.6317 16.4711C18.4577 16.7962 18.1188 16.9992 17.75 16.9992H13.2146C12.9719 18.6952 11.5132 19.999 9.75 19.999C7.98677 19.999 6.52806 18.6952 6.28545 16.9992H1.75C1.38121 16.9992 1.04235 16.7962 0.868327 16.4711C0.694308 16.1459 0.71338 15.7514 0.917951 15.4445L2.75 12.6966V7.99961C2.75 4.77556 4.92983 2.06062 7.89614 1.24806ZM8.33535 16.9992C8.54127 17.5817 9.09689 17.9991 9.75 17.9991C10.4031 17.9991 10.9587 17.5817 11.1646 16.9992H8.33535Z",
    fill: "#0078B2"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAlertBlue);
export default __webpack_public_path__ + "static/media/Ic_AlertBlue.95914ab0a62c508d2ea459cdfe8fdcbe.svg";
export { ForwardRef as ReactComponent };